var $35da740d59af89ba$exports = {};
// Task 1
const $35da740d59af89ba$var$taskOneContainer = document.getElementById("taskOneContainer");
let $35da740d59af89ba$var$index = 0;
const $35da740d59af89ba$var$id = setInterval(()=>{
    if ($35da740d59af89ba$var$index == 4) clearInterval($35da740d59af89ba$var$id);
    $35da740d59af89ba$var$taskOneContainer.innerHTML = "";
    const text = document.createElement("p");
    $35da740d59af89ba$var$index++;
    text.textContent = "Message #" + $35da740d59af89ba$var$index;
    $35da740d59af89ba$var$taskOneContainer.append(text);
}, 1000);
// Task 2
const $35da740d59af89ba$var$taskTwoContainer = document.getElementById("taskTwoContainer");
const $35da740d59af89ba$var$sqr = document.createElement("div");
const $35da740d59af89ba$var$id2 = setInterval(()=>{
    let rScale = Math.random() * 1.1;
    let r1 = Math.random() * 255;
    let r2 = Math.random() * 255;
    let r3 = Math.random() * 255;
    $35da740d59af89ba$var$sqr.style.backgroundColor = "rgb(" + r1 + "," + r2 + "," + r3 + ")";
    $35da740d59af89ba$var$sqr.style.width = "200px";
    $35da740d59af89ba$var$sqr.style.height = "200px";
    $35da740d59af89ba$var$sqr.style.scale = rScale;
    $35da740d59af89ba$var$taskTwoContainer.append($35da740d59af89ba$var$sqr);
}, 2000);
// Task 3
const $35da740d59af89ba$var$taskThreeContainer = document.getElementById("taskThreeContainer");
const $35da740d59af89ba$var$el1 = document.getElementById("el1");
const $35da740d59af89ba$var$el2 = document.getElementById("el2");
const $35da740d59af89ba$var$el3 = document.getElementById("el3");
const $35da740d59af89ba$var$p = document.createElement("p");
$35da740d59af89ba$var$p.style.fontSize = "16px";
const $35da740d59af89ba$var$headText = document.createElement("p");
$35da740d59af89ba$var$headText.textContent = "\u0423 \u0432\u0430\u0441 10 \u0441\u0435\u043A\u0443\u043D\u0434, \u0449\u043E\u0431 \u0437\u0440\u043E\u0431\u0438\u0442\u0438 200+ \u043D\u0430\u0442\u0438\u0441\u043A\u0430\u043D\u044C";
$35da740d59af89ba$var$headText.style.fontSize = "20px";
function $35da740d59af89ba$var$checkClicked() {
    if ($35da740d59af89ba$var$clicked >= 200) {
        alert("\u041F\u0435\u0440\u0435\u043C\u043E\u0433\u0430. \u041D\u0430\u0442\u0438\u0441\u043A\u0430\u043D\u044C 200");
        return true;
    }
}
let $35da740d59af89ba$var$clicked = 0;
$35da740d59af89ba$var$el1.addEventListener("click", (e)=>{
    e.preventDefault();
    $35da740d59af89ba$var$checkClicked();
    $35da740d59af89ba$var$clicked++;
    $35da740d59af89ba$var$p.textContent = $35da740d59af89ba$var$clicked;
});
$35da740d59af89ba$var$el2.addEventListener("click", (e)=>{
    e.preventDefault();
    $35da740d59af89ba$var$checkClicked();
    $35da740d59af89ba$var$clicked++;
    $35da740d59af89ba$var$p.textContent = $35da740d59af89ba$var$clicked;
});
$35da740d59af89ba$var$el3.addEventListener("click", (e)=>{
    e.preventDefault();
    $35da740d59af89ba$var$checkClicked();
    $35da740d59af89ba$var$clicked++;
    $35da740d59af89ba$var$p.textContent = $35da740d59af89ba$var$clicked;
});
$35da740d59af89ba$var$taskThreeContainer.prepend($35da740d59af89ba$var$p);
const $35da740d59af89ba$var$id3 = setInterval(()=>{
    $35da740d59af89ba$var$clicked = 0;
}, 10000);
// Task 4
const $35da740d59af89ba$var$enteredTime = Number(prompt("\u0427\u0430\u0441?:"));
setTimeout(()=>{
    alert("Timer(" + $35da740d59af89ba$var$enteredTime + " second)");
}, $35da740d59af89ba$var$enteredTime * 1000);


//# sourceMappingURL=asyncDz10.e57c1e7e.js.map
